import {I18n} from '@aws-amplify/core';
import {FlexiAddButton} from '@flexinet/ui-components';
import {useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';

interface AddButtonProps {
    buttonText?: string;
    size?: string;
    onClick?: () => void;
}

export const AddButton = ({
    buttonText = 'Add Subscription',
    size = 'sm',
    onClick,
}: AddButtonProps) => {
    const navigate = useNavigate();

    if (typeof onClick === 'undefined') {
        onClick = () => {
            navigate('add');
        };
    }

    return (
        <FlexiAddButton
            onClick={onClick}
            size={size}
        >
            {I18n.get(buttonText)}
        </FlexiAddButton>
    );
};

AddButton.propTypes = {
    buttonText: PropTypes.string,
    size: PropTypes.string,
    onClick: PropTypes.func,
};